import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Subscription } from 'rxjs';
import { UXControllerService } from '../service/controller/ux-controller.service';

@Component({
  selector: 'app-cosy-collection',
  templateUrl: './cosy-collection.component.html',
  styleUrls: ['./cosy-collection.component.css']
})
export class CosyCollectionComponent implements OnInit {
  @ViewChild('collEditorTemplate') collEditorTemplate: TemplateRef<any>;

  public objectRegistryItems: any;
  public objectRegistryTypes: any;
  private objectTypeDID: string = "";
  private objectRegistrySearchText: string = "";
  private objectRegistryPagerActivePage: number = 1;
  private activeID: string;
  private selectedRowCol: number = -1;
  private objectTypeStyle: string = "";
  private objectTypeClass: string = "form-group col-md-6 padding-top";
  private searchText: string = "Suchtext...";
  public isAttributeSets: boolean = false;
  private activeEntityID: string = '';

  public modalRef: BsModalRef;
  private subscriptionCollection: Subscription;

  constructor(
    private uxControllerService: UXControllerService,
    private modalService: BsModalService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService
  ) { }

  ngOnInit() {
    this.cosyCommunicationControllerService.getObjectRegistryTypes(this.uxControllerService.sessionID).subscribe(
      types => {
        this.objectRegistryTypes = types['value'];
        this.objectTypeDID = this.objectRegistryTypes[0].ObjectTypeDID;
      },
      error => console.error('ERROR: ', error)
    );
    this.subscriptionCollection = this.uxControllerService.showCollection.subscribe(
      () => this.openCollectionEditor()
    );
  }

  openCollectionEditor() {
    if (this.uxControllerService.appStateID == 'f5fa9d9a-4985-45d2-8839-bd19f8ef70e9') this.isAttributeSets = true; //AttributeSets
    this.cosyCommunicationControllerService.getContextKey(this.uxControllerService.sessionID, "ActiveEntityID").subscribe(
      key => this.activeEntityID = key["value"],
      error => {console.error('No ContextKey: ', error); this.showCollectionEditor()},
      () => this.showCollectionEditor()
    );
  }

  showCollectionEditor() {
    if (this.uxControllerService.appStateID == 'b0ac19a8-3cf4-4336-b089-c6e50babb08c') { //GMX Warengruppe EV
      this.objectTypeDID = "F93F7CF0-644B-4744-9C65-D381263F5836";
      this.objectTypeStyle = "display: none";
      this.objectTypeClass = "form-group col-md-12 padding-top";
      this.searchText = "Produktsuche";
      this.modalRef = this.modalService.show(this.collEditorTemplate)
    }
    else if (this.uxControllerService.appStateID == 'f5fa9d9a-4985-45d2-8839-bd19f8ef70e9') { //AttributeSets
      this.objectTypeDID = "03f16433-ca30-4f82-a798-4914f6698170";
      this.objectTypeStyle = "display: none";
      this.objectTypeClass = "form-group col-md-12 padding-top";
      this.searchText = "Attribute";
      this.cosyCommunicationControllerService.getObjectRegistryList(this.uxControllerService.sessionID, this.objectRegistrySearchText, "[DisplayName]", 5, this.objectRegistryPagerActivePage, this.objectTypeDID, this.activeEntityID).subscribe(
        apps => this.objectRegistryItems = apps,
        error => console.error('ERROR: ', error),
        () => this.modalRef = this.modalService.show(this.collEditorTemplate)
      );
    }
    else {
      this.cosyCommunicationControllerService.getObjectRegistryList(this.uxControllerService.sessionID, this.objectRegistrySearchText, "[DisplayName]", 5, this.objectRegistryPagerActivePage, this.objectTypeDID, this.activeEntityID).subscribe(
        apps => this.objectRegistryItems = apps,
        error => console.error('ERROR: ', error),
        () => this.modalRef = this.modalService.show(this.collEditorTemplate)
      );
    }
}

  objectTypeChange(objectTypeDID: string) {
    this.objectTypeDID = objectTypeDID;
    this.objectRegistryPagerActivePage = 1;
    this.processSearchCollection();
  }

  objectRegistrySearchTextChange() {
    this.objectRegistryPagerActivePage = 1;
    this.processSearchCollection();
  }

  setActiveRowCol(index) {
    this.selectedRowCol = index;
  };

  objectRegistryPageChange(event: any): void {
    this.objectRegistryPagerActivePage = event.page;
    this.processSearchCollection();
  }

  processSearchCollection() {
    document.body.style.cursor = "wait";
    if (this.uxControllerService.appStateID == 'b0ac19a8-3cf4-4336-b089-c6e50babb08c') { //GMX Warengruppe EV
      this.objectTypeDID = "F93F7CF0-644B-4744-9C65-D381263F5836";
      this.objectTypeStyle = "display: none";
      this.objectTypeClass = "form-group col-md-12 padding-top";
      this.searchText = "Produktsuche";
      this.cosyCommunicationControllerService.getObjectRegistryList(this.uxControllerService.sessionID, this.objectRegistrySearchText, "[DisplayName]", 5, this.objectRegistryPagerActivePage, this.objectTypeDID, this.activeEntityID).subscribe(
        apps => this.objectRegistryItems = apps,
        error => console.error('ERROR: ', error),
        () => document.body.style.cursor = "default"
      );
    }
    else if (this.uxControllerService.appStateID == 'f5fa9d9a-4985-45d2-8839-bd19f8ef70e9') { //AttributeSets
      this.objectTypeDID = "03f16433-ca30-4f82-a798-4914f6698170";
      this.objectTypeStyle = "display: none";
      this.objectTypeClass = "form-group col-md-12 padding-top";
      this.searchText = "Attribute";
      this.cosyCommunicationControllerService.getObjectRegistryList(this.uxControllerService.sessionID, this.objectRegistrySearchText, "[DisplayName]", 5, this.objectRegistryPagerActivePage, this.objectTypeDID, this.activeEntityID).subscribe(
        apps => this.objectRegistryItems = apps,
        error => console.error('ERROR: ', error),
        () => document.body.style.cursor = "default"
      );
    }
    else {
      this.cosyCommunicationControllerService.getObjectRegistryList(this.uxControllerService.sessionID, this.objectRegistrySearchText, "[DisplayName]", 5, this.objectRegistryPagerActivePage, this.objectTypeDID, this.activeEntityID).subscribe(
        apps => this.objectRegistryItems = apps,
        error => console.error('ERROR: ', error),
        () => document.body.style.cursor = "default"
      );
    }
  }

  addToCollection() {
    let entityID: string;
    this.objectRegistryTypes.forEach(element => {
      if (element.ObjectTypeDID == this.objectTypeDID) entityID = element.EntityID;
    });
    this.cosyCommunicationControllerService.getSessionKey(this.uxControllerService.sessionID, "ID").subscribe(
      key => this.activeID = key["value"],
      error => console.error('ERROR: ', error),
      () => {
        if (this.selectedRowCol != -1) {
          this.cosyCommunicationControllerService.addToCollection(this.uxControllerService.sessionID, this.activeID, entityID, [(this.objectRegistryItems['value'])[this.selectedRowCol].ID], [this.objectRegistryItems['value'][this.selectedRowCol].DisplayName]).subscribe(
            error => console.error('ERROR: ', error),
          )
        }
      });
  }

  removeSearchValueCollection() {

  }
  ngOnDestroy() {
    this.subscriptionCollection.unsubscribe();
  }

}
